import type { FC } from 'react';
import { memo, useEffect, useRef } from 'react';
import { useClickAway } from 'ahooks';
import { useNodes } from 'reactflow';
import PanelOperatorPopup from './nodes/_base/components/panel-operator/panel-operator-popup';
import type { Node } from './types';
import { useStore } from './store';
import { usePanelInteractions } from './hooks';
type NodeContextmenuProps = {
  threeShow?: boolean,
};
const NodeContextmenu: FC<NodeContextmenuProps> = ({threeShow}) => {
  const ref = useRef(null);
  const nodes = useNodes();
  const { handleNodeContextmenuCancel, handlePaneContextmenuCancel } =
    usePanelInteractions();
  const nodeMenu = useStore((s) => s.nodeMenu);
  const currentNode = nodes.find(
    (node) => node.id === nodeMenu?.nodeId,
  ) as Node;

  useEffect(() => {
    if (nodeMenu) handlePaneContextmenuCancel();
  }, [nodeMenu, handlePaneContextmenuCancel]);

  useClickAway(() => {
    handleNodeContextmenuCancel();
  }, ref);

  if (!nodeMenu || !currentNode) return null;
  console.log('threeShow', threeShow);
  return (
    <div
      className="absolute z-[9]"
      style={{
        left: nodeMenu.left - (threeShow ? 300 : 0),
        top: nodeMenu.top,
      }}
      ref={ref}
    >
      <PanelOperatorPopup
        id={currentNode.id}
        data={currentNode.data}
        onClosePopup={() => handleNodeContextmenuCancel()}
        showHelpLink={false}
      />
    </div>
  );
};

/** @name 节点右键菜单 */
export default memo(NodeContextmenu);
